import { AccordionDetails, styled } from "@mui/material";

export const StyledAccordionDetails = styled(AccordionDetails)`
  border-top: 1px solid ${({ theme }) => theme.palette.divider};
`;
